import { ICaseDecision } from "../model/CaseDecision";
import { ICaseDecisionService } from "../service/CaseDecisionService";

export default class ArchiveCaseDecisionInteractor {
  private caseDecisionService: ICaseDecisionService;

  constructor({ caseDecisionService }: any) {
    this.caseDecisionService = caseDecisionService;
  }

  async execute(item: ICaseDecision) {
    return this.caseDecisionService.archiveCaseDecision(item.id);
  }
}
